var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusWidget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m555 401.58h540v123.74h-540z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m555 566.26h540v123.74h-540z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m555 735h540v123.74h-540z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m1050 1027.5h-495v-123.74h540v78.75c0 24.844-20.156 45-45 45z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m1050 172.5h-495v180h540v-135c0-24.844-20.156-45-45-45zm-112.5 112.5h-225c-12.422 0-22.5-10.078-22.5-22.5s10.078-22.5 22.5-22.5h225c12.422 0 22.5 10.078 22.5 22.5s-10.078 22.5-22.5 22.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m105 401.58h405v123.74h-405z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m105 566.26h405v123.74h-405z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m105 735h405v123.74h-405z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m105 982.5v-78.75h405v123.74h-360c-24.844 0-45-20.156-45-45z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m150 172.5c-24.844 0-45 20.156-45 45v135h405v-180zm225 112.5h-135c-12.422 0-22.5-10.078-22.5-22.5s10.078-22.5 22.5-22.5h135c12.422 0 22.5 10.078 22.5 22.5s-10.078 22.5-22.5 22.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusWidget);
export default __webpack_public_path__ + "static/media/status-widget.70b3af599a76923b721b96ee1fa371bb.svg";
export { ForwardRef as ReactComponent };